export default "<div id=\"page-wrapper\">\n    <div class=\"app-auth\">\n        <router-outlet></router-outlet>\n    </div>\n</div>"